import React, { Component } from 'react';

class TestRoute extends Component {

  render() {
    return (      
        <div>
          <h1>this is a test!</h1>
        </div>
    );
  }
}

export default TestRoute;



/** WEBPACK FOOTER **
 ** ./src/TestRoute.js
 **/